import React, { useCallback } from 'react';

import styled from 'styled-components';

import { ClientFormRegister } from '@/@types/client';
import Button from '@/components/Button';
import FormInput from '@/components/Form/Input';
import { Loader } from '@/components/Loader';
import configMask from '@/config/mask';
import { useAuth } from '@/contexts/auth';
import { useFormValues } from '@/hooks/use-form-values';

const StyledButton = styled(Button)`
  margin-top: 1.8rem;
`;

type Props = {
  onSuccess: () => void;
};

const Register = ({ onSuccess }: Props) => {
  const { handleRegister } = useAuth();

  const {
    formValues,
    loadingFormValues,
    handleChangeFormValues,
    handleSubmitFormValues,
    handleClearFormValues,
  } = useFormValues<ClientFormRegister>({
    CPF_CLIENTE: '',
    NOME_CLIENTE: '',
    DATA_NASCIMENTO_CLIENTE: '',
    TELEFONE_CLIENTE: '',
    EMAIL_CLIENTE: '',
    SENHA_CLIENTE: '',
  });

  const onSubmit = useCallback(
    async (_, values) => {
      try {
        await handleRegister(values);
        handleClearFormValues();
        onSuccess();
        // eslint-disable-next-line no-empty
      } catch (err) {}
    },
    [handleClearFormValues, handleRegister, onSuccess],
  );

  return (
    <form onSubmit={handleSubmitFormValues(onSubmit)}>
      <FormInput
        name="NOME_CLIENTE"
        value={formValues.NOME_CLIENTE}
        placeholder="Nome"
        onChange={handleChangeFormValues}
        required
      />

      <FormInput
        required
        name="CPF_CLIENTE"
        value={formValues.CPF_CLIENTE}
        onChange={handleChangeFormValues}
        mask="###.###.###-##"
        placeholder="Digite seu cpf"
        replace={{ to: /[^0-9]/g }}
      />

      <FormInput
        required
        name="DATA_NASCIMENTO_CLIENTE"
        value={formValues.DATA_NASCIMENTO_CLIENTE}
        onChange={handleChangeFormValues}
        mask={configMask.ddmmyy}
        placeholder="Data de Nascimento"
        replace={{ to: /[^0-9/]/g }}
      />

      <FormInput
        required
        name="TELEFONE_CLIENTE"
        value={formValues.TELEFONE_CLIENTE}
        onChange={handleChangeFormValues}
        mask={configMask.phone}
        placeholder="Telefone"
        replace={{ to: /[^0-9()-]/g }}
      />

      <FormInput
        type="email"
        name="EMAIL_CLIENTE"
        value={formValues.EMAIL_CLIENTE}
        onChange={handleChangeFormValues}
        placeholder="E-mail"
        required
      />

      <FormInput
        type="password"
        name="SENHA_CLIENTE"
        value={formValues.SENHA_CLIENTE}
        onChange={handleChangeFormValues}
        placeholder="Senha"
        required
      />

      <StyledButton type="submit" disabled={loadingFormValues}>
        {loadingFormValues ? <Loader /> : 'Criar conta'}
      </StyledButton>
    </form>
  );
};

export default React.memo(Register);
